import actions from './actions'
import mutations from './mutations'

const state = {
  taskApiError: null,
  changes: {
    eventDayId: null,
    scheduleId: null,
    tasks: []
  },
}

const getters = {
  taskApiError: state => state.taskApiError
}

export default {
  state,
  getters,
  mutations,
  actions
}
